import {SpaceTrSpace, Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import Container = Phaser.GameObjects.Container;
import {ArenaLeague, BattleLog, LeagueDto} from "@/store/arena/types";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import TimeUtils from "@/utils/time-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import ResourceUtils from "@/utils/resource-utils";
import ArenaUtils from "@/utils/arena-utils";
import {HorizontalStandardPanel} from "@/scenes.ui/horizontal-standard-panel";
import {keys} from "lodash";

export class ArenaDailyRewardPanel extends HorizontalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, league: ArenaLeague, position: number, rewards: Map<string, number>, callback: ()=> void) {
        super(scene, canvas, Tr('daily.arena.reward').toUpperCase());

        let y = -80;
        let x = 0;

        let leagueImg = SpriteUtils.addImage(scene, x, y, Keys.ATLAS_LEAGUE, ArenaUtils.getLeagueImg(league), 0.9);
        let splashImg = SpriteUtils.addImage(scene, x, y + 30, Keys.WHEEL_SPLASH, undefined, 1.3, 0.8);
        splashImg.alpha = 0.5;

        let leagueName = TextUtils.addTextAdvanced(scene, ArenaUtils.getLeagueName(league),
            x, y + 90,
            ArenaUtils.getLeagueColor(league), 15, 'normal',  500, 'left', 2, Fonts.MYRIADPRO_REGULAR);
        leagueName.setOrigin(0.5)

        let positionText = TextUtils.addTextAdvanced(scene, Tr('position.in.rating') + ": " + position,
            x, y + 120,
            '#ffdfdf', 16, 'normal',  500, 'left', 2, Fonts.MYRIADPRO_REGULAR);
        positionText.setOrigin(0.5)

        y += 150+10;
        let x0 = 10 - Array.from(rewards.values()).filter(value => value != 0).length * 50;
        rewards.forEach((value, key) => {
            if(value == 0) return;
            let rewardImage = SpriteUtils.addImage(scene, x0, y , ResourceUtils.findRewardTypeIcon(key), undefined, 1).setOrigin(0, 0.5);

            let reward = TextUtils.addTextAdvanced(scene, value.toString(),
                rewardImage.getBottomRight().x!/CU.S, y,
                '#ffdfdf', 15, 'normal', 500, 'left', 2, Fonts.MYRIADPRO_REGULAR);
            reward.setPadding({right:5})

            this.add([reward, rewardImage]);
            x0 = reward.getBottomRight().x!/CU.S + 20
        });

        this.addButton(Tr('get'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, callback, false);

        this.add([splashImg, leagueImg, positionText, leagueName]);

    }

    protected addButton(text: string, buttonBackground: string, buttonAtlas: string | undefined, buttonIcon: string, callback?: () => unknown, disableAutoClose?:  boolean): void {
        let button = this.addCustomButton(this.getCloseButtonX(), this.getCloseButtonY(), text, buttonBackground, buttonAtlas, buttonIcon, callback, disableAutoClose);
        button.setScale(0.8)
        button.y+=25;
    }
}
